<template>
    <div class="main">
        <myheader></myheader>
        <div class="mains flex">
            <myleft></myleft>
            <div class="right">
                <div class="top flex">
                    <div class="btn flex">
                        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增</el-button>
                        <el-button type="danger" icon="el-icon-delete" size="small" @click="deleteSelect">删除选中项</el-button>
                    </div>
                    <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" class="demo-form-inline flex">
                        <el-form-item prop="name">
                            <el-input v-model="formInline.name" @input="handlerChange" placeholder="请输入委托单位" prefix-icon="el-icon-search"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('formInline')">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="bot">
                    <el-table
                        ref="singleTable"
                        v-loading.fullscreen.lock="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData"
                        border
                        stripe
                        style="width: 100%"
                        max-height="95%"
                        :default-sort = "{prop: 'id', order: 'descending'}"
                        @selection-change="handleSelectionChange">
                        <el-table-column
                        type="selection"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        fixed
                        prop="id"
                        label="ID"
                        width="113">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="委托单位">
                        </el-table-column>
                        <el-table-column
                        prop="createtime"
                        :formatter="dateFormat"
                        label="时间">
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="150">
                        <template slot-scope="scope">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="page"
                            :page-size="per_page"
                            layout="total, prev, pager, next, jumper"
                            :total="total"
                            :pager-count="5">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
    import { basis_entrust_index, basis_entrust_add, basis_entrust_edit, basis_entrust_del } from "@/api";
    import myheader from "@/components/common/header";
    import myleft from "@/components/common/left";
      export default {
          data () {
              return {
                // 筛选
                formInline: {
                    name: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入委托单位', trigger: 'blur' }
                    ]
                },
                // 数据列表
                loading: false,
                tableData: [],
                total: 0,
                per_page: 10, //每页多少数据
                page: 1
              }
            },
            components: {
                myheader: myheader,
                myleft: myleft
            },
            methods: {
                // 列表
                basisEntrustIndex() {
                    this.loading = true;
                    basis_entrust_index().then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                            this.total = res.data.data.total // 数据总条数
                        }
                    });
                },
                // 删除选中项
                deleteSelect() {
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {

                        var val = this.multipleSelection;
                        var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串

                        basis_entrust_del({
                            ids: multipleSelection
                        }).then(res => {
                            console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.basisEntrustIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                            
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 筛选
                submitForm(formName) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // console.log(this.formInline.name);
                            this.loading = true;
                            basis_entrust_index({
                                params: {
                                    name: this.formInline.name,
                                    page: this.page
                                }
                            }).then((res) => {
                                // console.log(res.data.data);
                                this.loading = false;
                                if (res.data.code == 1) {
                                    this.tableData = res.data.data.data;
                                    this.total = res.data.data.total // 数据总条数
                                }
                            });
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                },
                // 搜索框输入数据为空显示初始数据
                handlerChange(e) {
                    // console.log(e);
                    if (e == '') {
                        this.basisEntrustIndex(); // 调用数据列表函数
                    }
                },
                // 当选择项发生变化时会触发该事件
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                    // var multipleSelection = val.map(item => item['id']).join(','); // 勾选值数组转字符串
                    // console.log(multipleSelection)
                },
                // 新增-委托单位
                handleAdd() {
                    this.$prompt('请输入委托单位', '新增', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern: /\S/,
                        inputErrorMessage: '请输入委托单位'
                        }).then(({ value }) => {

                        basis_entrust_add({
                            name: value
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.basisEntrustIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                        
                        this.$message({
                            type: 'success',
                            message: '您新增了委托单位: ' + value
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消新增'
                        });
                    });
                },
                // 行数据编辑-委托单位
                handleEdit(row) {
                    console.log(row); // 获取当前行委托单位
                    this.$prompt('请输入委托单位', '编辑', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputValue: row.name, // 委托单位赋值到输入框
                        inputPattern: /\S/,
                        inputErrorMessage: '请输入委托单位'
                        }).then(({ value }) => {

                        basis_entrust_edit({
                            id: row.id,
                            name: value
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.basisEntrustIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                        
                        this.$message({
                            type: 'success',
                            message: '您修改了委托单位: ' + value
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消修改'
                        });
                    });
                },
                // 行数据删除
                handleDelete(row) {
                    // console.log(row.id);
                    this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {

                        basis_entrust_del({
                            ids: row.id
                        }).then(res => {
                            // console.log(res);
                            if (res.data.code == 1) {
                                this.page = 1;
                                this.basisEntrustIndex(); // 调用数据列表函数
                            }
                        }).catch(error => {
                            console.log(error);
                        });
                        
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });          
                    });
                },
                // 每页条数
                handleSizeChange(val) {
                    console.log(`每页 ${val} 条`);
                },
                // 当前页
                handleCurrentChange(page) {
                    // console.log(`当前页: ${page}`);
                    this.loading = true;
                    basis_entrust_index({
                        params: { page }
                    }).then((res) => {
                        // console.log(res.data.data);
                        this.loading = false;
                        if (res.data.code == 1) {
                            this.tableData = res.data.data.data;
                        }
                    });
                },
                // 时间戳转日期格式
                dateFormat(row) {
                    // console.log(row.createtime*1000)
                    let data = row.createtime * 1000
                    let dtime = new Date(data)
                    const year = dtime.getFullYear()
                    let month = dtime.getMonth() + 1
                    if (month < 10) {
                        month = '0' + month
                    }
                    let day = dtime.getDate()
                    if (day < 10) {
                        day = '0' + day
                    }
                    let hour = dtime.getHours()
                    if (hour < 10) {
                        hour = '0' + hour
                    }
                    let minute = dtime.getMinutes()
                    if (minute < 10) {
                        minute = '0' + minute
                    }
                    let second = dtime.getSeconds()
                    if (second < 10) {
                        second = '0' + second
                    }
                    return year+ '-' + month+ '-' + day + ' ' + hour + ':' + minute + ':' + second
                }
            },
            created() {
                this.basisEntrustIndex() // 列表
            },
            // 解决表格fixed错位问题
            updated() {
                if (this.$refs.singleTable && this.$refs.singleTable.doLayout) {
                    this.$refs.singleTable.doLayout()
                }
            }
      }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
      .ystatus{
        width: 100%;
        text-align: center;
        color: #847f7f;
      }
      .wstatus{
        width: 100%;
      }
  </style>
  


// WEBPACK FOOTER //
// src/components/danwei.vue